import { articlesApi } from "../api/articlesApi"

 /* A partir de una ruta FTP que no es publica obtenemos otra ruta para visualizar el contenido
  * tanto si el tipo es imagen o pdf 
  */
export const getUrlFromAStream = async (ruta, type) => {
    const response = await articlesApi.getFile({ route: ruta }) // nos devuelve un stream
    //await new Promise(resolve => setTimeout(resolve, 1500))
    const stremArray = await response.data
    // Create a Blob from the PDF/Imagen Stream
    const file = new Blob(
        [stremArray],
        { type: type})
    //Build a URL from the file
    return URL.createObjectURL(file)
}


export const getUrlFromAStream2 = async (ruta, type) => {
    articlesApi.getFile({ route: ruta }).then ( x=> {
        debugger
            const stremArray = x.data
    // Create a Blob from the PDF/Imagen Stream
    const file = new Blob(
        [stremArray],
        { type: type})
    //Build a URL from the file
    return URL.createObjectURL(file)
    }

    )

}